<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <div class="spacing--margin-horizontal spacing--margin-top">
    <div class="spacing--margin-bottom">
      <div class="spacing--margin-top flex--row flex--wrap">
        <div class="flex--column">
          <span class="text--small text--bold label">
            {{ 'tail-biting.detail.for' | translate }}
          </span>
          <span class="text--small label">
            {{ getDate() | agrDate: 'dd-MM-yyyy' }}
          </span>
        </div>
      </div>
    </div>

    <div class="spacing--margin-top">
      <div class="spacing--margin-bottom">
        <div class="spacing--margin-top flex--row flex--wrap">
          <div class="flex--column">
            <span class="text--small text--gray label">
              {{ 'tail-biting.detail.customer.name' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ data.customer?.name }}
            </span>
          </div>
          <div class="flex--column spacing--margin-left">
            <span class="text--small text--gray label">
              {{ 'tail-biting.detail.location.name' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ location?.name }}
            </span>
          </div>
          <div class="flex--column spacing--margin-left">
            <span class="text--small text--gray label">
              {{ 'tail-biting.detail.location.address' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ location?.street }} {{ location?.houseNumber }} {{ location?.houseNumberAddition }}
            </span>
          </div>
          <div class="flex--column spacing--margin-left">
            <span class="text--small text--gray label">
              {{ 'tail-biting.detail.location.postalcode' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ location?.postalCode }}
            </span>
          </div>
          <div class="flex--column spacing--margin-left">
            <span class="text--small text--gray label">
              {{ 'tail-biting.detail.location.city' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ location?.city }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="flex--column">
      <mat-form-field class="flex__child--auto spacing--margin-top">
        <mat-label>{{ 'tail-biting.detail.label.name' | translate }}</mat-label>
        <input
          matInput
          formControlName="tailBitingName"
          placeholder="{{ 'tail-biting.detail.label.name' | translate }}"
          data-test="tail-biting-detail__name"
        />
        <mat-error *ngIf="formGroup.controls.tailBitingName.invalid">
          {{ 'tail-biting.detail.error-name' | translate }}</mat-error
        >
      </mat-form-field>
    </div>

    <div class="flex--column spacing--padding-right">
      <mat-form-field class="flex__child--auto spacing--margin-top">
        <mat-label>{{ 'tail-biting.detail.label.pigType' | translate }}</mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          placeholder="{{ 'tail-biting.detail.pigType' | translate }}"
          formControlName="pigType"
          data-test="tail-biting__pig-type"
        >
          <mat-option *ngFor="let pigType of pigTypes" [value]="pigType">
            {{ 'tail-biting.detail.pigType.' + pigType | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex--column spacing--padding-right">
      <mat-form-field class="flex__child--auto spacing--margin-top">
        <mat-label>{{ 'tail-biting.detail.label.tailDocking' | translate }}</mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          placeholder="{{ 'tail-biting.detail.tailDocking' | translate }}"
          formControlName="tailDocking"
          data-test="tail-biting__tail-docking"
        >
          <mat-option [value]="true">
            {{ 'tail-biting.detail.yes' | translate }}
          </mat-option>
          <mat-option [value]="false">
            {{ 'tail-biting.detail.no' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex--column" *ngIf="isMobile$ | async">
      <mat-form-field class="flex__child--auto spacing--margin-top">
        <mat-select
          [hideSingleSelectionIndicator]="true"
          placeholder="{{ 'tail-biting.detail.pen-select' | translate }}"
          [(value)]="selectedTabIndex"
          data-test="tail-biting-detail__pen-select"
        >
          <mat-option *ngFor="let tab of this.tabs; let i = index" [value]="i"
            >{{ 'tail-biting.detail.pen' | translate }} {{ i + 1 }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div class="">
      <mat-tab-group
        animationDuration="0"
        [(selectedIndex)]="selectedTabIndex"
        color="accent"
        [ngClass]="penTabsClass"
        [mat-stretch-tabs]="false"
      >
        <mat-tab *ngFor="let tab of this.tabs; let i = index" class="">
          <ng-template mat-tab-label
            >{{ 'tail-biting.detail.pen' | translate }} {{ i + 1 }}</ng-template
          >
          <app-tail-biting-detail-pen-form
            [penFormGroup]="penFormGroups[i]"
            [index]="i"
            (deletePen)="delete($event)"
            [canDelete]="canDeletePen"
            [isMobile]="isMobile$ | async"
          >
          </app-tail-biting-detail-pen-form>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</agr-form-dialog>
